import { useQuery } from '@tanstack/react-query';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { GlCodeResponse } from 'src/types/GLCode';
import axiosInstance from 'src/utils/axios';

async function fetchAllGlCodes(companyId: string): Promise<GlCodeResponse[]> {
  if (!companyId) {
    return [];
  }
  const res = await axiosInstance.get<GlCodeResponse[]>(api.getAllGlCode(companyId));
  const data = res.data.map((glCode) => ({
    ...glCode,
    selected: false,
    isDirty: false,
    name: `${glCode.code} ${glCode.description}`,
    rowId: uuid(),
  }));
  return data;
}

export function useGetAllGlCodeQuery(companyId: string) {
  return useQuery<GlCodeResponse[]>({
    queryKey: [...queryKeys.glCode.all(companyId)],
    queryFn: () => fetchAllGlCodes(companyId),
    enabled: Boolean(companyId),
  });
}
